import { render, staticRenderFns } from "./RecoveryByEmailForm.vue?vue&type=template&id=6b30468d&scoped=true&"
import script from "./RecoveryByEmailForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryByEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryByEmailForm.vue?vue&type=style&index=0&id=6b30468d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30468d",
  null
  
)

export default component.exports